export function initRawStreamAnalyzer(analyzer: AnalyserNode) {
  analyzer.smoothingTimeConstant = 0; // disable blackman windowing.  Should not matter for time domain data? we'll see
  analyzer.fftSize = 32768; // big enough for 24K samples (1/2 second of lookback)
  analyzer.channelCountMode = "explicit";
  analyzer.channelCount = 1;
}

/**
 * When webm/pcm isn't supported (safari, firefox), instead capture and transfer raw PCM data.
 * 
 * Shortcomings:
 * (1) no way to detect stream blips, it'll just start being wrong
 * (2) expect discontinuities between these slices to cause noise freqs
 */
export function getLatestHalfSecondRawStream(analyzer: AnalyserNode): Blob {
  // could have less lossy data with AudioWorklet - https://stackoverflow.com/questions/79365428/inconsistent-pcm-audio-data-captured-from-the-same-video-using-audioworkletnode
  // But at the cost of more asynchronous postMessage bullshit
  const amplitudeArr = new Float32Array(24000); // analyzer.fftSize);
  analyzer.getFloatTimeDomainData(amplitudeArr);
  const halfSecAmps = amplitudeArr; // amplitudeArr.slice(8768); // 32768 minus 24000 - for the latest 1/2 second at 48KHz
  return new Blob([halfSecAmps.buffer], { type: "application/octet-stream" });
}
